import React, { createContext, useContext, useState, useEffect } from 'react';
import { authAPI } from '../api';

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth debe ser usado dentro de AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(null);

  useEffect(() => {
    const storedToken = localStorage.getItem('lexduo_token');
    const storedUser = localStorage.getItem('lexduo_user');
    
    if (storedToken && storedUser) {
      // Verificar si el token no ha expirado
      try {
        const payload = JSON.parse(atob(storedToken.split('.')[1]));
        const expiry = payload.exp * 1000;
        if (Date.now() >= expiry) {
          localStorage.removeItem('lexduo_token');
          localStorage.removeItem('lexduo_user');
          setLoading(false);
          return;
        }
      } catch (e) {
        localStorage.removeItem('lexduo_token');
        localStorage.removeItem('lexduo_user');
        setLoading(false);
        return;
      }
      setToken(storedToken);
      setUser(JSON.parse(storedUser));
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    try {
      const response = await authAPI.login({ email, password });
      
      const { access_token, user: userData } = response.data;
      
      // Guardar token y usuario
      localStorage.setItem('lexduo_token', access_token);
      localStorage.setItem('lexduo_user', JSON.stringify(userData));
      
      setToken(access_token);
      setUser(userData);
      
      return { success: true };
    } catch (error) {
      console.error('Error en login:', error);
      
      const errorMessage = error.response?.data?.detail || 'Error de conexión';
      
      return { 
        success: false, 
        error: errorMessage 
      };
    }
  };

  const logout = () => {
    localStorage.removeItem('lexduo_token');
    localStorage.removeItem('lexduo_user');
    setToken(null);
    setUser(null);
  };

  const value = {
    user,
    token,
    loading,
    login,
    logout,
    isAuthenticated: !!user
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
